import { render } from "./Apropos.vue?vue&type=template&id=d0df6c12&scoped=true"
import script from "./Apropos.vue?vue&type=script&lang=js"
export * from "./Apropos.vue?vue&type=script&lang=js"

import "./Apropos.vue?vue&type=style&index=0&id=d0df6c12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0df6c12"]])

export default __exports__